export const NewWindow = () => {
  return (
    <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 7V1H11"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 1L9 9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 10.1511V14C15 15.6569 13.6569 17 12 17H4C2.34315 17 1 15.6569 1 14V6C1 4.34315 2.34315 3 4 3H7.84885"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  )
}
